import React, { useState } from 'react';
import { Link } from 'react-router-dom';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:8080'}/api/auth/forgot-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();
      
      if (response.ok) {
        setSubmitted(true);
      } else {
        setError(data.error || 'Failed to send reset email. Please try again.');
      }
    } catch (err) {
      console.error('Forgot password error:', err);
      setError('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <div className="page">
        <header>
          <img className="logo" src="/logo.png" alt="Stewart Valuation Intelligence" />
          <h1>Remote Inspection</h1>
        </header>

        <main className="main">
          <div className="card" style={{maxWidth: '500px'}}>
            <div style={{textAlign: 'center', marginBottom: '24px'}}>
              <div style={{
                fontSize: '48px',
                marginBottom: '16px'
              }}>
                ✉️
              </div>
              <h2>Check Your Email</h2>
            </div>

            <p style={{marginBottom: '16px', color: '#64748b', lineHeight: '1.6'}}>
              If an account exists with <strong>{email}</strong>, we've sent a password reset link to that address.
            </p>

            <p style={{marginBottom: '24px', color: '#64748b', lineHeight: '1.6'}}>
              Please check your email and click the link to reset your password. The link will expire in 2 hours.
            </p>

            <div style={{
              padding: '12px 16px',
              marginBottom: '16px',
              backgroundColor: '#dbeafe',
              border: '1px solid #3b82f6',
              borderRadius: '8px',
              color: '#1e40af',
              fontSize: '14px'
            }}>
              <strong>💡 Tip:</strong> Check your spam folder if you don't see the email within a few minutes.
            </div>

            <div className="section">
              <Link to="/login">
                <button type="button" style={{width: '100%'}}>
                  Back to Login
                </button>
              </Link>
            </div>
          </div>
        </main>
      </div>
    );
  }

  return (
    <div className="page">
      <header>
        <img className="logo" src="/logo.png" alt="Stewart Valuation Intelligence" />
        <h1>Remote Inspection</h1>
      </header>

      <main className="main">
        <div className="card" style={{maxWidth: '450px'}}>
          <h2>Forgot Password</h2>
          <p style={{marginBottom: '24px', color: '#64748b'}}>
            Enter your email address and we'll send you a link to reset your password.
          </p>

          <form onSubmit={handleSubmit}>
            <div className="section">
              <label htmlFor="email">Email Address</label>
              <input
                id="email"
                type="email"
                placeholder="your.email@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="email"
                autoFocus
              />
            </div>

            {error && (
              <div style={{
                padding: '12px 16px',
                marginBottom: '16px',
                backgroundColor: '#fee2e2',
                border: '1px solid #ef4444',
                borderRadius: '8px',
                color: '#991b1b'
              }}>
                <strong>⚠️ Error:</strong> {error}
              </div>
            )}

            <div className="section">
              <button type="submit" disabled={loading}>
                {loading ? 'Sending...' : 'Send Reset Link'}
              </button>
            </div>
          </form>

          <p className="hint" style={{textAlign: 'center', marginTop: '20px'}}>
            Remember your password? <Link to="/login" style={{color: '#2563eb', textDecoration: 'none', fontWeight: '500'}}>Back to Login</Link>
          </p>
        </div>
      </main>
    </div>
  );
}

export default ForgotPassword;


